import type { MileageModalProps } from 'components/PageWrappers/AdDetails/components/CarSummary/MileageModal/MileageModal.typed';
import InfoModal from 'components/PageWrappers/AdDetails/components/CarSummary/InfoModal/InfoModal';
import { Link } from 'components/Toolkit/Button/Link';
const MileageModal = (props: MileageModalProps) => {
  const { isOpen, askToClose, mileageIndicator } = props;
  const {
    state,
    bodyType,
    mileageDifference,
    make,
    model,
    year,
    fuelType,
    medianMileage,
  } = mileageIndicator;
  const buttonText = 'Ok, got it!';
  const formattedBodyType =
    bodyType === 'SUV' || bodyType === 'MPV'
      ? bodyType
      : bodyType.toLowerCase();
  const formattedFuelType = fuelType.toLowerCase();
  const lessMoreText = state === 'Below' ? 'less' : 'more';
  const mileageInfoModalStates = {
    Below: {
      modalTitle: 'Below Average Mileage',
      modalBody: `This vehicle has approximately ${mileageDifference} ${lessMoreText} than the average ${year} ${make} ${model} ${formattedFuelType} ${formattedBodyType}, compared to similar cars on DoneDeal. The typical mileage for this vehicle is ${medianMileage}.`,
    },
    Same: {
      modalTitle: 'Average Mileage',
      modalBody: `This vehicle has approximately the same mileage as the average ${year} ${make} ${model} ${formattedFuelType} ${formattedBodyType}, compared to similar cars on DoneDeal. The typical mileage for this vehicle is ${medianMileage}.`,
    },
    Above: {
      modalTitle: 'Above Average Mileage',
      modalBody: `This vehicle has approximately ${mileageDifference} ${lessMoreText} than the average ${year} ${make} ${model} ${formattedFuelType} ${formattedBodyType}, compared to similar cars on DoneDeal. The typical mileage for this vehicle is ${medianMileage}.`,
    },
  };
  const { modalTitle, modalBody: modalBodyText } =
    mileageInfoModalStates[state];

  return (
    <InfoModal
      askToClose={askToClose}
      isOpen={isOpen}
      testId="mileage-info-modal"
      title={modalTitle}
      buttonText={buttonText}
    >
      <InfoModal.Text>{modalBodyText}</InfoModal.Text>
      <Link
        ofType={'SECONDARY'}
        underline
        href="https://hello.donedeal.ie/hc/en-us/articles/24005610893457-Car-Mileage-What-You-Need-To-Know"
        target="_blank"
        fontSize="M16"
      >
        Learn more about vehicle mileage
      </Link>
    </InfoModal>
  );
};

export { MileageModal };
